import { Plus } from "lucide-react"
import { UtmLinksContent, useUtmLinks } from "@/features/manage-utm-links"
import { Button } from "@/shared/ui/button"
import {
	type LoadedDraft,
	useBotWorkspace,
	WithDraft,
	WorkspaceSection,
	UtmHelp,
} from "@/widgets/bot-workspace"

const SUBTITLE =
	"Ссылка t.me/бот?start=метка запускает свою воронку и запоминает, откуда пришёл человек. Метки уже стоят в соцсетях, меняйте их осторожно."

/** «Аналитика → UTM-метки»: ссылки входа: сколько людей пришло и докуда дошло. */
export function UtmPage() {
	return (
		<WithDraft title="UTM-метки" subtitle={SUBTITLE}>
			{(state) => <UtmSection state={state} />}
		</WithDraft>
	)
}

function UtmSection({ state }: { state: LoadedDraft }) {
	const { bot } = useBotWorkspace()
	const utm = useUtmLinks({
		draft: state.draft,
		actions: state.actions,
		botId: bot.id,
		botUsername: bot.username,
	})

	return (
		<WorkspaceSection
			title="Метки"
			subtitle={SUBTITLE}
			help={<UtmHelp />}
			actions={
				<Button className="rounded-xl" onClick={utm.openCreate}>
					<Plus />
					Добавить метку
				</Button>
			}
		>
			<UtmLinksContent {...utm} />
		</WorkspaceSection>
	)
}
